import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  FormGroup,
  Input,
  CardHeader,
  CardTitle,
  CardBody,
  Button
} from "reactstrap"
import rest from '../../lib/rest'
import rotas from '../../services/rotas'
import Loading from 'lib/loading'
import FormConfiguracao from './formConfiguracao'
import Select from "react-select"
 
const Configuracao = () => {

  const [loading, setLoading]     = useState(true)
  const [listaLoja, setListaLoja] = useState([])
  const [filial, setFilial]       = useState(null)

  const listaLojas = () => {
    let lista = []
    try{
      const retorno = rest.get(rotas.lojas)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i] = {"value":ret.lista[i].filial_id, "label":ret.lista[i].fantasia}
          }
          setListaLoja(lista)
        }else{
          setListaLoja([])
        }
        setLoading(false)
      })
      return (lista)
    }catch(err){

    }
  }

  useEffect(() => {
    const load = loading
    if (load === true) {
      listaLojas()
    }
  }, [])

  // useEffect(() => {
  //   if (filial !== null) {
  //     // console.log(filial.value)
  //   }
  // }, [filial])

  if (loading) {
    return (
      <Loading tipo='paginas' />
    )
  }else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <CardTitle>CONFIGURAÇÃO DE LOJAS</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>

                  <Col md='12 p-3 border'>
                    <Row>
                      <Col md='2'>
                        <FormGroup className="m-0">
                          <Input
                            disabled
                            style     = {{background: '#F9F9F9'}}
                            name      = "loja_id"
                            id        = "loja_id"
                            value     = {filial !== null ? filial.value : ''}
                            // onChange  = {onChange('filial_id')}
                          />
                        </FormGroup>
                      </Col>

                      <Col md='10'>
                        <FormGroup className="m-0">
                          <Select
                            name          = "lojas"
                            placeholder   = "Selecione a loja"
                            options       = {listaLoja}
                            onChange      = {setFilial}
                          >
                          </Select>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>

                  <FormConfiguracao filial = {filial}>
                  </FormConfiguracao>
                  
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Configuracao
